import React, { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import styled from 'styled-components';
import { getUserData, checkInUser } from '../services/api';
import Loading from './Loading';

const CheckInContainer = styled.div`
  max-width: 600px;
  margin: 2rem auto;
  padding: 2rem;
  background-color: #ffffff;
  border-radius: 8px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
  text-align: center;
`;

const UserInfo = styled.div`
  margin: 2rem 0;
  padding: 1.5rem;
  background-color: #f8f9fa;
  border-radius: 8px;
`;

const StatusMessage = styled.div`
  margin: 2rem 0;
  padding: 1rem;
  border-radius: 4px;
  background-color: ${props => props.success ? '#d4edda' : '#f8d7da'};
  color: ${props => props.success ? '#155724' : '#721c24'};
`;

const Button = styled.button`
  background-color: #4285F4;
  color: white;
  border: none;
  padding: 0.75rem 1.5rem;
  border-radius: 4px;
  font-size: 1rem;
  cursor: pointer;
  transition: background-color 0.3s;

  &:hover {
    background-color: #3367d6;
  }

  &:disabled {
    background-color: #cccccc;
    cursor: not-allowed;
  }
`;

const CheckIn = () => {
  const { userId } = useParams();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(true);
  const [userData, setUserData] = useState(null);
  const [status, setStatus] = useState(null);
  const [checkingIn, setCheckingIn] = useState(false);

  useEffect(() => {
    const fetchUserData = async () => {
      setLoading(true);
      const result = await getUserData(userId);
      if (result.success) {
        setUserData(result.data);
      } else {
        setStatus({
          success: false,
          message: result.message
        });
      }
      setLoading(false);
    };

    fetchUserData();
  }, [userId]);

  const handleCheckIn = async () => {
    setCheckingIn(true);
    const result = await checkInUser(userId);
    setStatus({
      success: result.success,
      message: result.message
    });
    setCheckingIn(false);
  };

  if (loading) {
    return (
      <CheckInContainer>
        <h2>กำลังโหลดข้อมูล...</h2>
        <Loading />
      </CheckInContainer>
    );
  }

  return (
    <CheckInContainer>
      <h1>เช็คอินเข้างาน Linx OpenHouse</h1>

      {userData ? (
        <UserInfo>
          <h2>{userData.displayName}</h2>
          <p><strong>อีเมล:</strong> {userData.email}</p>
          {userData.company && <p><strong>บริษัท:</strong> {userData.company}</p>}
          {userData.jobTitle && <p><strong>ตำแหน่ง:</strong> {userData.jobTitle}</p>}
        </UserInfo>
      ) : (
        <StatusMessage success={false}>
          <p>ไม่พบข้อมูลผู้ใช้</p>
        </StatusMessage>
      )}

      {status && (
        <StatusMessage success={status.success}>
          <p>{status.message}</p>
        </StatusMessage>
      )}

      {userData && !status?.success && (
        <Button
          onClick={handleCheckIn}
          disabled={checkingIn}
        >
          {checkingIn ? 'กำลังเช็คอิน...' : 'เช็คอินเข้างาน'}
        </Button>
      )}

      {status?.success && (
        <div>
          <p>คุณสามารถเพิ่มบัตรเข้างานลงใน Wallet ได้:</p>
          <Button onClick={() => navigate(`/wallet/google/${userId}`)}>
            Google Wallet
          </Button>
          {' '}
          <Button onClick={() => navigate(`/wallet/apple/${userId}`)}>
            Apple Wallet
          </Button>
        </div>
      )}
    </CheckInContainer>
  );
};

export default CheckIn;
